const KEY = "dmn_utm";
const FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];

export const captureUtm = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    FIELDS.forEach((f) => {
      const v = params.get(f);
      if (v) found[f] = v.slice(0, 200);
    });
    if (!Object.keys(found).length) return;
    found.referrer = (document.referrer || "").slice(0, 300);
    found.landing_page = window.location.pathname;
    sessionStorage.setItem(KEY, JSON.stringify(found));
  } catch {}
};

export const getUtm = () => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(KEY) || "{}");
    if (!stored.referrer && document.referrer) stored.referrer = document.referrer.slice(0, 300);
    return stored;
  } catch {
    return {};
  }
};

export const utmPayload = () => {
  const u = getUtm();
  return {
    utm_source: u.utm_source || "",
    utm_medium: u.utm_medium || "",
    utm_campaign: u.utm_campaign || "",
    utm_term: u.utm_term || "",
    ad_content: u.utm_content || "",
    gclid: u.gclid || "",
    fbclid: u.fbclid || "",
    referrer: u.referrer || "",
    landing_page: u.landing_page || window.location.pathname,
  };
};
